import { createFileRoute } from "@tanstack/react-router";

import { UserSettingsPage } from "src/pages/UserSettingsPage";

export const Route = createFileRoute("/_auth/settings/")({
  component: UserSettingsPage,
});
